import type { ISerialize } from '@/objects/ISerialize';
import { WeatherData } from './WeatherData';
import { formatDateIso } from '@/utilities/dateutils';

export class WeatherResponse implements ISerialize {
    public LastUpdated: Date | null;

    public Latitude: number;

    public Longitude: number;

    public Timeseries: WeatherData[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { LastUpdated?: Date | null; Latitude?: number; Longitude?: number; Timeseries?: WeatherData[] }) {
        this.LastUpdated = values.LastUpdated ?? null;

        this.Latitude = values.Latitude ?? 0;

        this.Longitude = values.Longitude ?? 0;

        this.Timeseries = values.Timeseries ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"LastUpdated": ${this.LastUpdated ? '"' + formatDateIso(this.LastUpdated) + '"' : null}` +
            ',' +
            `"Latitude": ${JSON.stringify(this.Latitude)}` +
            ',' +
            `"Longitude": ${JSON.stringify(this.Longitude)}` +
            ',' +
            `"Timeseries": [ ${this.Timeseries.map((x) => (!x ? null : x?.serialize()))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of WeatherResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        LastUpdated?: Date | null;
        Latitude?: number;
        Longitude?: number;
        Timeseries?: WeatherData[];
    }): WeatherResponse {
        return new WeatherResponse(values);
    }

    public static _FromServerJson(json: any): WeatherResponse {
        return new WeatherResponse({
            LastUpdated: json.LastUpdated ? (json.LastUpdated instanceof Date ? json.LastUpdated : new Date(json.LastUpdated)) : null,
            Latitude: json.Latitude,
            Longitude: json.Longitude,
            Timeseries: json.Timeseries?.map((x: any) => WeatherData._FromServerJson(x)),
        });
    }

    /**
     * Creates an instance of WeatherResponse from another instance of WeatherResponse.
     * @param other The WeatherResponse you want to clone
     * @returns A cloned WeatherResponse
     */
    public static FromOther(other: WeatherResponse): WeatherResponse {
        return WeatherResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return WeatherResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'WeatherResponse';
}
